// Shared constants for the Film Clubs & Pop-Ups portal + its local demo mode.
//
// Pop-up rows live under the umbrella cinema_id below; each row's `theater`
// field carries the real location (a bar, gallery, rooftop…) and `series` the
// presenting club. The umbrella id is NOT in src/constants THEATERS, so these
// rows never render on the main calendar.
//
// DEMO MODE (?demo=1 on a dev host) renders sample events CLIENT-SIDE ONLY —
// there is no dev/prod Supabase split, so writing test rows would put them on
// the live site (and into watchlist alerts) instantly. Movie records are still
// READ from the real DB so posters and film links render true.
export const POPUP_CINEMA_ID = 'popup-events';

export function isDevHost() {
  return typeof window !== 'undefined' && /^(localhost|192\.168\.|10\.|127\.)/.test(window.location.hostname);
}

export function demoEnabled() {
  return isDevHost() && new URLSearchParams(window.location.search).has('demo');
}

const day = (offset, h) => { const d = new Date(); d.setDate(d.getDate() + offset); d.setHours(h, 0, 0, 0); return d.toISOString(); };

export const DEMO_EVENTS = [
  { id: 'demo-1', cinema_id: POPUP_CINEMA_ID, movie_id: '11474', cinema_movie_title: 'The Warriors', start_at: day(2, 20), theater: "The Owl's Head, Bay Ridge", series: 'Basement Cinema Club', booking_link: 'https://example.com' },
  { id: 'demo-2', cinema_id: POPUP_CINEMA_ID, movie_id: '3564', cinema_movie_title: 'The Rocky Horror Picture Show', start_at: day(2, 23), theater: 'Secret Loft, Bushwick', series: 'Midnight Mass NYC', booking_link: 'https://example.com' },
  { id: 'demo-3', cinema_id: POPUP_CINEMA_ID, movie_id: '139800', cinema_movie_title: '50 First Dates', start_at: day(5, 19), theater: 'Pine Box Rock Shop, East Williamsburg', series: null, booking_link: null },
];
